import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { PAY_STATUS_OPTIONS } from "../_status_labels";
import { sortByLabel } from "./_helpers";

export const select_pay_statuses: Query<Ctx> = async (_ctx, _params) =>
  sortByLabel(PAY_STATUS_OPTIONS);
